"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* tslint:disable */

/* eslint-disable */

/*
query FollowArtistPopoverQuery(
  $artistID: String!
) {
  artist(id: $artistID) {
    ...FollowArtistPopover_artist
    id
  }
}

fragment FollowArtistPopoverRow_artist on Artist {
  internalID
  name
  image {
    cropped(width: 45, height: 45) {
      url
    }
  }
}

fragment FollowArtistPopover_artist on Artist {
  related {
    suggestedConnection(first: 3, excludeFollowedArtists: true) {
      edges {
        node {
          id
          internalID
          ...FollowArtistPopoverRow_artist
        }
      }
    }
  }
}
*/
var node = function () {
  var v0 = [{
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "artistID",
    "type": "String!"
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "artistID"
  }],
      v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0
      /*: any*/
      ,
      "kind": "Fragment",
      "metadata": null,
      "name": "FollowArtistPopoverQuery",
      "selections": [{
        "alias": null,
        "args": v1
        /*: any*/
        ,
        "concreteType": "Artist",
        "kind": "LinkedField",
        "name": "artist",
        "plural": false,
        "selections": [{
          "args": null,
          "kind": "FragmentSpread",
          "name": "FollowArtistPopover_artist"
        }],
        "storageKey": null
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0
      /*: any*/
      ,
      "kind": "Operation",
      "name": "FollowArtistPopoverQuery",
      "selections": [{
        "alias": null,
        "args": v1
        /*: any*/
        ,
        "concreteType": "Artist",
        "kind": "LinkedField",
        "name": "artist",
        "plural": false,
        "selections": [{
          "alias": null,
          "args": null,
          "concreteType": "ArtistRelatedData",
          "kind": "LinkedField",
          "name": "related",
          "plural": false,
          "selections": [{
            "alias": null,
            "args": [{
              "kind": "Literal",
              "name": "excludeFollowedArtists",
              "value": true
            }, {
              "kind": "Literal",
              "name": "first",
              "value": 3
            }],
            "concreteType": "ArtistConnection",
            "kind": "LinkedField",
            "name": "suggestedConnection",
            "plural": false,
            "selections": [{
              "alias": null,
              "args": null,
              "concreteType": "ArtistEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [{
                "alias": null,
                "args": null,
                "concreteType": "Artist",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [v2
                /*: any*/
                , {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "internalID",
                  "storageKey": null
                }, {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }, {
                  "alias": null,
                  "args": null,
                  "concreteType": "Image",
                  "kind": "LinkedField",
                  "name": "image",
                  "plural": false,
                  "selections": [{
                    "alias": null,
                    "args": [{
                      "kind": "Literal",
                      "name": "height",
                      "value": 45
                    }, {
                      "kind": "Literal",
                      "name": "width",
                      "value": 45
                    }],
                    "concreteType": "CroppedImageUrl",
                    "kind": "LinkedField",
                    "name": "cropped",
                    "plural": false,
                    "selections": [{
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "url",
                      "storageKey": null
                    }],
                    "storageKey": "cropped(height:45,width:45)"
                  }],
                  "storageKey": null
                }],
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": "suggestedConnection(excludeFollowedArtists:true,first:3)"
          }],
          "storageKey": null
        }, v2
        /*: any*/
        ],
        "storageKey": null
      }]
    },
    "params": {
      "id": null,
      "metadata": {},
      "name": "FollowArtistPopoverQuery",
      "operationKind": "query",
      "text": "query FollowArtistPopoverQuery(\n  $artistID: String!\n) {\n  artist(id: $artistID) {\n    ...FollowArtistPopover_artist\n    id\n  }\n}\n\nfragment FollowArtistPopoverRow_artist on Artist {\n  internalID\n  name\n  image {\n    cropped(width: 45, height: 45) {\n      url\n    }\n  }\n}\n\nfragment FollowArtistPopover_artist on Artist {\n  related {\n    suggestedConnection(first: 3, excludeFollowedArtists: true) {\n      edges {\n        node {\n          id\n          internalID\n          ...FollowArtistPopoverRow_artist\n        }\n      }\n    }\n  }\n}\n"
    }
  };
}();

node.hash = '364b417ae6a387a733637fd589434356';
var _default = node;
exports.default = _default;
//# sourceMappingURL=FollowArtistPopoverQuery.graphql.js.map